import React from 'react';
import s from './CoborrowersList.scss';
import Button from '../../../Common/Button';
import DeleteIcon from '../../../../../assets/images/icons/clear-icon.svg';
import EditIcon from '../../../../../assets/images/icons/Edit_1.svg';

const CoborrowersList = ({ coborrowers, selectCoborrower, addCoborrower, deleteCoborrower, isEditing }) => (
    <div className={s.container}>
        {coborrowers.map(coborrower => (
            <div className={s.card} key={coborrower.number}>
                <p>{coborrower.first_name} {coborrower.last_name}</p>
                <Button className={s.edit} src={EditIcon} onClick={() => selectCoborrower(coborrower.number)}>Editar</Button>
                <Button className={s.delete} src={DeleteIcon} onClick={() => deleteCoborrower(coborrower.number)}>Eliminar</Button>
            </div>
        ))}
        {isEditing && <Button className={s.addNew} onClick={addCoborrower}>Agregar nuevo cotitular</Button>}
    </div>
)

export default CoborrowersList;
